"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTotalsCms = void 0;
var OrderTotalsCms = /** @class */ (function () {
    function OrderTotalsCms() {
        this.bundleTotalsTitle = 'Bundle totals';
        this.duetodayTitle = 'Due today';
        this.dueOn1stbillTitle = 'Due on 1st bill ';
        this.dueOn1stbillLabel = '(monthly & one-time charges)';
        this.subtotal = 'Subtotal';
        this.bundleLobNames = {
            accessory: 'Accessories',
            broadband: 'Internet',
            dtvnow: 'TV',
            dtvs: 'TV',
            iptv: 'TV',
            wireless: 'Wireless',
        };
        this.bundleLobLegalModal = {
            accessory: 'Accessories',
            broadband: 'Internet',
            dtvnow: '--TBD--',
            dtvs: 'TV',
            iptv: '--TBD--',
            wireless: 'Wireless',
        };
    }
    return OrderTotalsCms;
}());
exports.OrderTotalsCms = OrderTotalsCms;
//# sourceMappingURL=OrderTotals.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/OrderTotals/OrderTotals.cms.js
// module id = 1433
// module chunks = 8